import React, { Component, Fragment } from 'react';
import moment from 'moment';

export default class Publish extends Component {
  constructor(props) {
    super(props);
    this.upt = this.upt.bind(this);
    this.setUpt = this.setUpt.bind(this);
    this.publish = this.publish.bind(this);
    this.state = {
      upt: false
    }
    this.times = [
      { value: '5', desc: 'for 5 minutes' },
      { value: '15', desc: 'for 15 minutes' },
      { value: '60', desc: 'for 1 hour' },
      { value: '120', desc: 'for 2 hours'},
      { value: '180', desc: 'for 3 hours'},
      { value: '1440', desc: 'for 24 hours'},
      { value: '2880', desc: 'for 48 hours'},

      { value: 'e9', desc: 'until 9AM / 9:00'},
      { value: 'e12', desc: 'until 12AM / 12:00'},
      { value: 'e17', desc: 'until 5PM / 17:00'},
      { value: 'e18', desc: 'until 6PM / 18:00'},
      { value: 'e21', desc: 'until 9PM / 21:00'},
      { value: 'e0', desc: 'until midnight'},
      { value: 'e3', desc: 'until 3AM / 3:00'},
      { value: 'e6', desc: 'until 6AM / 6:00'},
    ]
  }
  componentWillMount() {
    const upt = moment(this.state.upt).isValid() ? moment(this.state.upt).format("YYYY-MM-DDTHH:mm") : moment().format("YYYY-MM-DDTHH:mm");
    this.setState({ upt: upt });
  }

  render() {
    const time = moment();
    const upt = moment(this.state.upt);
    const format = "YYYY-MM-DDTHH:mm";
    console.log(time);
    return (
      <Fragment>
        <h1>Publish</h1>
        <h2>How long do we show your message?</h2>
        <ul>
        {
          this.times.map(item => (
            <li key={item.value}><label><input type="radio" name="publishtime" checked={ item.value === this.props.data.upt ? 'checked' : false } onChange={ this.upt } value={ item.value }/>{ item.desc }</label></li>
          ))
        }
        </ul>
        <h2>Post published until</h2>
        <input type="datetime-local" name="upt" onChange={ this.setUpt } value={ upt.format(format) } min={ time.format(format) } max={ time.add(2, 'days').format(format) } />
        <p>Your post will expire { upt.calendar() }, { upt.endOf(time).fromNow() }.</p>
        <p>Before posting, you need to read and agree to our <a href="/rules">Terms and policies</a>.</p>
        <button id="publish" onClick={ this.publish } type="button">Publish</button>
      </Fragment>
    )
  }
  upt(e) {

    const value = e.target.value;
    let upt = false;

    if(value.slice(0, 1) === "e") {

      let code = parseInt(value.slice(1, value.length), 10);
      console.log(code);

      if(code === 0) {
        upt = moment().add(1, 'day').hours(0).minutes(0);
        console.log('null kood');
      } else if(code < 24) {
        //today or tomorrow
        console.log('code', code, moment().hours());
        if(moment().hours() > code) {
          upt = moment().add(1, 'day').hours(code).minutes(0);
          console.log(upt);

        } else upt = moment().hours(code).minutes(0);
      } else {
        console.log('code', code);
        upt = moment();

      }

    } else {

      upt = parseInt(value, 10);
      console.log(upt);
      if(upt <= 2880) upt = moment().add(upt, 'minutes');
      else upt = moment();

    }

    this.setState({ upt: upt.format("YYYY-MM-DDTHH:mm") }, () => {
      console.log(this.state);
      this.props.onUPTAdd(this.state);
    });
  }
  setUpt(e) {
    console.log('UPT:', e.target.value);
    let time = moment();
    let upt = moment(e.target.value).isValid ? moment(e.target.value) : moment();
    let before = upt.isBefore(time, 'minute');
    console.log(upt, time);
    let after = upt.isAfter(time.add(48, 'hours'), 'minute');
    console.log(before, after);
    if(before) upt = moment();
    if(after) upt = moment().add(48, 'hours');

    this.setState({ upt: upt.format("YYYY-MM-DDTHH:mm") }, () => {
      this.props.onUPTAdd(this.state)
    });
  }
  publish(e) {
    this.props.onPublish(true);
  }
}



// WEBPACK FOOTER //
// ./src/view/new-publish.jsx